import { render } from "./FeatureTwoLayout.vue?vue&type=template&id=68bb7e56&scoped=true&ts=true"
import script from "./FeatureTwoLayout.vue?vue&type=script&lang=ts"
export * from "./FeatureTwoLayout.vue?vue&type=script&lang=ts"

import "./FeatureTwoLayout.vue?vue&type=style&index=0&id=68bb7e56&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-68bb7e56"]])

export default __exports__